import { render, staticRenderFns } from "./RegisterFunctionGroup.vue?vue&type=template&id=2b629dd7&scoped=true&"
import script from "./RegisterFunctionGroup.vue?vue&type=script&lang=js&"
export * from "./RegisterFunctionGroup.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFunctionGroup.vue?vue&type=style&index=0&id=2b629dd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b629dd7",
  null
  
)

export default component.exports